module.exports = __webpack_public_path__ + "img/small_eye_redchart01.2d5f95a8.jpg";